// extracted by mini-css-extract-plugin
export default {"loginForm":"LoginForm_loginForm__YNbvH","loginOptions":"LoginForm_loginOptions__cdWkW","loginButton":"LoginForm_loginButton__7o-sC","signUpButton":"LoginForm_signUpButton__d8QCU"};